import { render, staticRenderFns } from "./ChoosePayment.vue?vue&type=template&id=72ea8a04&scoped=true&"
import script from "./ChoosePayment.vue?vue&type=script&lang=js&"
export * from "./ChoosePayment.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePayment.vue?vue&type=style&index=0&id=72ea8a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ea8a04",
  null
  
)

export default component.exports